import {formatEuros} from "@mytour/platform";
import {Badge} from "reactstrap";

type Props = {
  cycle: "monthly" | "yearly";
  amountCentimes: number;
  defaultCentimes: number;
};

export function CustomCard({cycle, amountCentimes, defaultCentimes}: Props) {
  const cycleLabel = cycle === "monthly" ? "mois" : "an";
  const isFree = amountCentimes === 0;
  const isOverride = amountCentimes !== defaultCentimes;
  const defaultEuros = formatEuros(defaultCentimes / 100);
  const amountEuros = formatEuros(amountCentimes / 100);

  return (
    <div style={{textAlign: "center"}}>
      <h4>
        {isOverride && (
          <>
            <span className="strikethrough-diagonal">{defaultEuros}€</span>{" "}
          </>
        )}
        {!isFree && `${amountEuros}€ / ${cycleLabel}`}
      </h4>
      {isFree ? (
        <p>
          <Badge
            color="light"
            pill
            style={{
              color: "var(--mt-color-action)",
              padding: "0.25em 0.15em",
              fontSize: "20px",
              marginRight: "4px",
            }}
          >
            Gratuit
          </Badge>
          soit 0€ / {cycleLabel}
        </p>
      ) : (
        <p>
          Un tarif <b>négocié</b>
        </p>
      )}
    </div>
  );
}
